import React from "react";
import "./WhyChooseUs.scss";

const reasonsData = [
  {
    number: "01",
    title: "Experiencia comprobada",
    description:
      "Contamos con trayectoria en proyectos residenciales y comerciales, desarrollando soluciones en vidrio y aluminio con acabados profesionales.",
  },
  {
    number: "02",
    title: "Materiales de alta calidad",
    description:
      "Trabajamos con cristal templado, aluminio y herrajes que ofrecen resistencia, estética y durabilidad para distintos tipos de espacio.",
  },
  {
    number: "03",
    title: "Instalación profesional",
    description:
      "Cada proyecto se ejecuta con atención al detalle, precisión en medidas y un proceso de instalación que cuida tanto funcionalidad como presentación.",
  },
  {
    number: "04",
    title: "Atención personalizada",
    description:
      "Nos adaptamos a las necesidades de cada cliente para desarrollar propuestas a medida, tanto en proyectos habitacionales como comerciales.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us" id="por-que-elegirnos">
      <div className="why-choose-us__container">
        <div className="why-choose-us__top">
          <span className="why-choose-us__eyebrow">Por qué elegirnos</span>

          <div className="why-choose-us__heading">
            <h2 className="why-choose-us__title">
              Un aliado confiable para proyectos en vidrio y aluminio
            </h2>

            <p className="why-choose-us__intro">
              Combinamos experiencia, calidad en materiales y atención cercana
              para desarrollar soluciones funcionales, modernas y bien
              ejecutadas en cada proyecto.
            </p>
          </div>
        </div>

        <div className="why-choose-us__layout">
          <div className="why-choose-us__main-card">
            <span className="why-choose-us__main-label">Nuestra fortaleza</span>

            <h3 className="why-choose-us__main-title">
              Más que instalar, nos enfocamos en entregar espacios bien resueltos
            </h3>

            <p className="why-choose-us__main-text">
              Nuestro trabajo busca integrar diseño, funcionalidad y acabados de
              alto nivel para que cada solución en vidrio y aluminio no solo
              cumpla con su propósito, sino que también eleve la imagen del
              espacio.
            </p>

            <div className="why-choose-us__stats">
              <div className="why-choose-us__stat">
                <h4>10+</h4>
                <p>Años de experiencia</p>
              </div>

              <div className="why-choose-us__stat">
                <h4>500+</h4>
                <p>Instalaciones realizadas</p>
              </div>

              <div className="why-choose-us__stat">
                <h4>200+</h4>
                <p>Clientes satisfechos</p>
              </div>
            </div>
          </div>

          <div className="why-choose-us__grid">
            {reasonsData.map((item) => (
              <article className="why-choose-us__card" key={item.number}>
                <div className="why-choose-us__card-top">
                  <span className="why-choose-us__card-number">{item.number}</span>
                  <span className="why-choose-us__card-line"></span>
                </div>

                <h3 className="why-choose-us__card-title">{item.title}</h3>
                <p className="why-choose-us__card-description">
                  {item.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;